import React from 'react';
import ReactDOM from 'react-dom/client';

import './globals.css'
import {RouterProvider} from "react-router-dom";
import {Toaster} from "@/components/ui/toaster";
import {routes} from "@/routes";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


const Wrapper = () => {
  return (
    <React.StrictMode>
      <main>
        <RouterProvider router={routes}/>
      </main>
      <Toaster/>
    </React.StrictMode>
  )
}


root.render(
  <Wrapper />
);
